var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 489,
    height: 484,
    viewBox: "0 0 489 484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.333 476.833C374.199 476.833 478.666 372.366 478.666 243.5C478.666 114.634 374.199 10.167 245.333 10.167C116.467 10.167 12 114.634 12 243.5C12 372.366 116.467 476.833 245.333 476.833Z",
    fill: "#00A997"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.287 162.693C366.571 168.95 366.571 179.095 360.287 185.352L223.742 321.307C217.458 327.564 207.269 327.564 200.985 321.307L132.713 253.33C126.429 247.073 126.429 236.928 132.713 230.671C138.997 224.414 149.186 224.414 155.471 230.671L212.363 287.318L337.529 162.693C343.814 156.436 354.003 156.436 360.287 162.693Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c23871eeecc6b1e6a149116f6842d2b9.svg";
export { ForwardRef as ReactComponent };